import React, { useState } from 'react';

import { ChevronRight } from 'react-feather';

import styles from './BusinessInfoTile.module.scss';

/**
 * Compact horizontal row tile for a business in a list — used by
 * BusinessesListAll, BusinessesListSearch, BusinessesListRecommended, and
 * FollowedBusinesses. This component didn't exist yet (it was assumed to
 * already be part of the shared `components` library, same as
 * CustomerCouponCard) — built here to match.
 *
 * Props:
 *   data    — business object: { id, name, logo, street, city: { name },
 *             postal_code, is_advertised }
 *   first   — true for the first tile in a list (no extra top margin needed
 *             in a flex/gap layout, but kept for API parity with
 *             CustomerCouponCard's `first` prop and in case spacing needs
 *             differ later)
 *   onPress — click handler, typically navigates to business details
 */
const getInitials = name => {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
};

const BusinessInfoTile = ({ data, first, onPress }) => {
  const [logoFailed, setLogoFailed] = useState(false);
  const { name, logo, street, city, postal_code: postalCode, is_advertised: isAdvertised } = data || {};

  const addressParts = [street, city?.name, postalCode].filter(Boolean);
  const address = addressParts.join(', ');

  return (
    <button
      type="button"
      className={first ? `${styles.tile} ${styles.first}` : styles.tile}
      onClick={onPress}
    >
      {logo && !logoFailed ? (
        <img src={logo} alt={name || ''} className={styles.logo} onError={() => setLogoFailed(true)} />
      ) : (
        <div className={styles.logoFallback}>{getInitials(name)}</div>
      )}

      <div className={styles.info}>
        <p className={styles.name}>
          {name}
          {isAdvertised && <span className={styles.sponsoredBadge}>SPONSORED</span>}
        </p>
        {address && <p className={styles.address}>{address}</p>}
      </div>

      <ChevronRight size={18} className={styles.chevron} />
    </button>
  );
};

export default BusinessInfoTile;